import React, { useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BestSellerBanner from "./BestSellerBanner";
import ProductList from "./ProductList";
import HomeTrendingSection from "../Home/HomeTrendingSection";

const HomepageBestseller = () => {
  const [cartItems, setCartItems] = useState([]);

  return (
    <>
      <Header />
      <BestSellerBanner />
      <ProductList />
      <HomeTrendingSection />
      {/* <Footer /> */}
    </>
  );
};


export default HomepageBestseller;